import {Dialog} from "@mui/material";
import React from "react";
import PrimaryButton from "../button/PrimaryButton";
import SecondaryButton from "../button/SecondaryButton";
import PrimaryGreenButton from "../button/PrimaryGreenButton";
import SecondaryGreenButton from "../button/SecondaryGreenButton";

export default function CustomPointGreenPopup(props) {
  const {
    onClose,
    selectedValue,
    open,
    // confirmType = true,
  } = props;

  const handleClose = () => {
    onClose(selectedValue);
  };

  return (
    <Dialog onClose={handleClose} open={open} fullWidth={true} maxWidth="xl">
      <div className="pb-[36px] pt-[24px] px-[23px] rounded-[4px]">
        {props.title && <p className="text-lightGreen text-[28px] text-center">{props.title}</p>}
        <p className="text-gray text-[18px] text-center whitespace-pre-line">{props.desc}</p>
        <div className="bg-green rounded-[8px] py-[12px] mt-[12px]">
          <p className="text-white text-[20px] text-center">คุณได้รับ Coin</p>
          <p className="text-white text-[52px] text-center leading-[84%]">{props.point} คะแนน</p>
        </div>
        <div className="flex itesm-center gap-[13px] justify-center mt-[24px]">
          {props.cancelFunction && (
            <SecondaryGreenButton
              variant="outlined"
              className={props.actionFunction ? 'w-full' : 'w-1/2'}
              onClick={() => props.cancelFunction()}
            >
              {props.cancelText ? props.cancelText : "ยกเลิก"}
            </SecondaryGreenButton>
          )}
          {props.actionFunction && (
            <PrimaryGreenButton
              onClick={() => props.actionFunction()}
              variant="outlined"
              className="w-full"
            >
              {props.actionText ? props.actionText : "บันทึก"}
            </PrimaryGreenButton>
          )}
        </div>
      </div>
    </Dialog>
  );
}
